import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["data-component-name"]
const _hoisted_2 = ["id", "name", "placeholder", "value", "required", "checked"]
const _hoisted_3 = ["for"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "o-form__validation" }
const _hoisted_7 = {
  key: 0,
  class: "o-form__validation__required"
}
const _hoisted_8 = {
  key: 1,
  class: "o-form__validation__required"
}
const _hoisted_9 = { class: "o-form__validation__error" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_inputlabel = _resolveComponent("inputlabel")

  return (!$props.disabledIDs.includes($props.field.id))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "data-component-name": _ctx.$options.name,
        class: _normalizeClass($options.wrapperClasses)
      }, [
        _createVNode(_component_inputlabel, { field: $props.field }, null, 8 /* PROPS */, ["field"]),
        _createElementVNode("div", {
          class: _normalizeClass(["o-form__item", {'o-checkbox__group': true}])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.field.inputChoices, (choice, ci) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass({
                    'o-checkbox__wrap': true,
                    'o-checkbox__wrap': true
                }),
              key: 'cb-'+ci+'-'+$props.field.id,
              style: {"display":"block"}
            }, [
              _withDirectives(_createElementVNode("input", _mergeProps({
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($props.field.value) = $event)),
                class: { 
                        'o-checkbox': true,
                        'o-checkbox': true,
                        'readonly': $props.field.inputReadonly === true,
                        'required': $data.requiredField === true
                    }
              }, _toHandlers($data.readOnlyHandlers, true), {
                type: "checkbox",
                id: 'input-' +ci+'-'+$props.field.id,
                name: ($props.field.inputChoices.length>1) ? $props.field.inputName+'[]' : $props.field.inputName,
                placeholder: $props.field.inputPlaceholder,
                value: (String(choice.value).trim() != '') ? choice.value : choice.text,
                required: ($props.field.inputRequired === true && $props.field.value!==null && $props.field.value.length == 0) ? 'required' : false,
                checked: ($props.field.value?.includes(choice.value)) ? 'checked' : false
              }), null, 16 /* FULL_PROPS */, _hoisted_2), [
                [_vModelCheckbox, $props.field.value]
              ]),
              _createElementVNode("label", {
                class: _normalizeClass({
                        'o-checkbox-label': true,
                        'o-checkbox-label': true
                    }),
                for: 'input-' + ci + '-' + $props.field.id
              }, [
                _createCommentVNode(" Inline SVG if available in svgContentMap "),
                (choice.picto && $data.svgContentMap[choice.picto])
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      innerHTML: $data.svgContentMap[choice.picto]
                    }, null, 8 /* PROPS */, _hoisted_4))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("span", {
                  innerHTML: (String(choice.text).trim() != '') ? choice.text : choice.value
                }, null, 8 /* PROPS */, _hoisted_5)
              ], 8 /* PROPS */, _hoisted_3),
              _createElementVNode("div", _hoisted_6, [
                ($props.field.inputChoices.length<2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx._t('Ce champ est obligatoire.')), 1 /* TEXT */))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx._t('Vous devez choisir au moins un élément.')), 1 /* TEXT */)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx._t('Ce champ est invalide.')), 1 /* TEXT */)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ], 10 /* CLASS, PROPS */, _hoisted_1))
    : _createCommentVNode("v-if", true)
}